
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blocked",
      function () {
        return require("private-next-pages/blocked.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blocked"])
      });
    }
  